<template>
  <v-dialog
    v-model="navigation.CRMWhatsappContactAddressDialogIsVisible"
    @update:model-value="navigation.CRMWhatsappContactAddressDialogIsVisible == false ? closeCRMWhatsappContactAddressDialog() : null"
    max-width="65vw"
    @contextmenu.prevent="null"
    style="user-select: none; cursor: default;"
  >
    <v-card>
      <div style="max-height: 90vh; display: flex; flex-direction: column;">
        <div style="position: sticky; top: 0; z-index: 10; background: white;">
          <v-card color="primary" rounded="0" elevation="0">
            <div class="twoColumnContainer">
              <div class="titleContainer">
                <div style="display: flex; align-items: center;">
                  <v-icon color="indigo" size="large">mdi-map-marker</v-icon>
                  <v-icon color="indigo" style="margin-right: 10px;">{{ {'insert': 'mdi-plus-circle', 'update': 'mdi-pencil', 'delete': 'mdi-delete'}[navigation.CRMWhatsappContactAddressDialogAction] }}</v-icon>
                  <h3>{{ {'insert': 'AGREGAR', 'update': 'ACTUALIZAR', 'delete': 'ELIMINAR'}[navigation.CRMWhatsappContactAddressDialogAction] }} DIRECCIÓN DEL CONTACTO</h3>
                </div>
              </div>
              <div class="buttonsContainer">
                <v-btn @click="closeCRMWhatsappContactAddressDialog()" color="error" class="hoverableText">
                  <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
                  <p>CERRAR</p>
                </v-btn>
              </div>
            </div>
          </v-card>
          <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
        </div>
        <div style="flex: 1; overflow-y: auto;">
          <template v-if="loader.getSystemInformationData || loader.selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialog">
            <div style="height: 500px; width: 100%;">
              <AppLoaderScreen
                :appLogoSize="'x-small'"
                :loadingText="'Cargando dirección del contacto'"
                :dotsToAnimate="3"
                style="width: 100%; height: 100%;"
              ></AppLoaderScreen>
            </div>
          </template>
          <template v-else>
            <div style="padding: 15px;">
              <v-text-field
                ref="CRMWhatsappContactLatitudeLongitudeLocationName"
                v-model="input.CRMWhatsappContactAddressName"
                :loader="loader.generalLoader"
                :disabled="loader.generalLoader || navigation.CRMWhatsappContactAddressDialogAction == 'delete'"
                label="Nombre"
                variant="outlined"
                density="compact"
                autocomplete="off"
                prepend-inner-icon="mdi-alpha-a-box"
                clearable
                hide-details
                style="margin-bottom: 15px;"
              ></v-text-field>
              <v-textarea
                v-model="input.CRMWhatsappContactAddressDescription"
                :loader="loader.generalLoader"
                :disabled="loader.generalLoader || navigation.CRMWhatsappContactAddressDialogAction == 'delete'"
                label="Descripción"
                variant="outlined"
                density="compact"
                autocomplete="off"
                prepend-inner-icon="mdi-alpha-b-box"
                rows="3"
                max-rows="5"
                auto-grow
                clearable
                hide-details
                style="margin-bottom: 15px;"
              ></v-textarea>
              <v-textarea
                ref="CRMWhatsappContactAddressAddress"
                v-model="input.CRMWhatsappContactAddressAddress"
                :loader="loader.generalLoader"
                :disabled="loader.generalLoader || navigation.CRMWhatsappContactAddressDialogAction == 'delete'"
                label="Dirección"
                variant="outlined"
                density="compact"
                autocomplete="off"
                prepend-inner-icon="mdi-link"
                rows="3"
                max-rows="5"
                auto-grow
                clearable
                hide-details
                style="margin-bottom: 15px;"
              ></v-textarea>
            </div>
            <v-card color="indigo" elevation="0" style="height: 2px;"></v-card>
            <v-card color="primary" elevation="0" rounded="0" style="padding: 15px;">
              <v-tooltip :disabled="validateInputForCRMWhatsappContactAddressDialog(false).success" location="top"> 
                <template v-slot:activator="{ props }">
                  <div v-bind="props">
                    <v-btn 
                      @click="navigation.CRMWhatsappContactAddressDialogAction == 'insert' ? insertCRMWhatsappContactAddress() : (navigation.CRMWhatsappContactAddressDialogAction == 'update' ? updateCRMWhatsappContactAddress() : deleteCRMWhatsappContactAddress())" 
                      :disabled="!validateInputForCRMWhatsappContactAddressDialog(false).success || loader.selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialog || loader.generalLoader" 
                      color="indigo"
                      class="hoverableText"
                      block
                    >
                      <v-icon style="margin-right: 10px;">{{ {'insert': 'mdi-plus-circle', 'update': 'mdi-pencil', 'delete': 'mdi-delete'}[navigation.CRMWhatsappContactAddressDialogAction] }}</v-icon>
                      <h3>{{ {'insert': 'AGREGAR', 'update': 'ACTUALIZAR', 'delete': 'ELIMINAR'}[navigation.CRMWhatsappContactAddressDialogAction] }} DIRECCIÓN DEL CONTACTO</h3>
                    </v-btn>
                  </div>
                </template>
                <span style="max-width: 400px; display: block;">{{ validateInputForCRMWhatsappContactAddressDialog(false).result }}</span>
              </v-tooltip>
            </v-card>
          </template>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<style scoped>
  .twoColumnContainer {
    padding: 15px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    align-items: center;
  }
  .titleContainer {
    display: flex;
    justify-content: flex-start;
  }
  .buttonsContainer {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }
  .twoInputContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  @media (max-width: 1200px) {
    .twoColumnContainer {
      grid-template-columns: repeat(1, 1fr);
    }
    .titleContainer {
      justify-content: center;
    }
    .buttonsContainer {
      justify-content: center;
    }
    .twoInputContainer {
      grid-template-columns: repeat(1, 1fr);
    }
  }
</style>
  
<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import AppLoaderScreen from '@/components/AppLoaderScreen.vue';

  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: 
    {
      AppLoaderScreen
    },
    data: () => 
    ({
      input: 
      {
        CRMWhatsappContactAddressName: null,
        CRMWhatsappContactAddressDescription: null,
        CRMWhatsappContactAddressAddress: null
      },
      navigation: 
      {
        CRMWhatsappContactID: null,
        CRMWhatsappContactAddressID: null,
        CRMWhatsappContactAddressDialogAction: null,
        CRMWhatsappContactAddressDialogIsVisible: false
      },
      loader: 
      {
        getSystemInformationData: false,
        generalLoader: false,
        selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialog: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgentID: null,
        CRMLocalities: [],
        tooltipDisabled: false
      }
    }),

    methods:
    {
      async selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialog(){
        this.loader.selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialog = true;
        const selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgentID
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
          'CRMWhatsappContactAddressID': this.navigation.CRMWhatsappContactAddressID
        };
        const selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactLocation/functions/selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialog', selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialogRequestQuery);
        if (selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialogResult.success){
          this.input.CRMWhatsappContactAddressName = selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialogResult.result.CRMWhatsappContactAddressName;
          this.input.CRMWhatsappContactAddressDescription = selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialogResult.result.CRMWhatsappContactAddressDescription;
          this.input.CRMWhatsappContactAddressAddress = selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialogResult.result.CRMWhatsappContactAddressAddress;
          this.loader.selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialog = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialog_error', 'error', 'Ha ocurrido un error inesperado al obtener la información de la dirección del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.closeCRMWhatsappContactAddressDialog();
        }
        this.loader.selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialog = false;
      },

      async insertCRMWhatsappContactAddress(){
        if (this.validateInputForCRMWhatsappContactAddressDialog(true).success){
          this.loader.generalLoader = true;
          const insertCRMWhatsappContactAddressRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgentID
            },
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
            'CRMWhatsappContactAddressName': this.input.CRMWhatsappContactAddressName,
            'CRMWhatsappContactAddressDescription': this.input.CRMWhatsappContactAddressDescription,
            'CRMWhatsappContactAddressAddress': this.input.CRMWhatsappContactAddressAddress
          };
          const insertCRMWhatsappContactAddressResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactLocation/functions/insertCRMWhatsappContactAddress', insertCRMWhatsappContactAddressRequestQuery);  
          if (insertCRMWhatsappContactAddressResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappContactAddress_success', 'success', `Se ha agregado la dirección "${this.input.CRMWhatsappContactAddressName}" del contacto`, null, true);
            this.closeCRMWhatsappContactAddressDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappContactAddress_error', 'error', `Ha ocurrido un error inesperado al agregar la dirección "${this.input.CRMWhatsappContactAddressName}" del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          }
          this.loader.generalLoader = false;
        }
      },

      async updateCRMWhatsappContactAddress(){
        if (this.validateInputForCRMWhatsappContactAddressDialog(true).success){
          this.loader.generalLoader = true;
          const updateCRMWhatsappContactAddressRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgentID
            },
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
            'CRMWhatsappContactAddressID': this.navigation.CRMWhatsappContactAddressID,
            'CRMWhatsappContactAddressName': this.input.CRMWhatsappContactAddressName,
            'CRMWhatsappContactAddressDescription': this.input.CRMWhatsappContactAddressDescription,
            'CRMWhatsappContactAddressAddress': this.input.CRMWhatsappContactAddressAddress
          };
          const updateCRMWhatsappContactAddressResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactLocation/functions/updateCRMWhatsappContactAddress', updateCRMWhatsappContactAddressRequestQuery);
          if (updateCRMWhatsappContactAddressResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContactAddress_success', 'success', `Se ha actualizado la dirección "${this.input.CRMWhatsappContactAddressName}" del contacto`, null, true);
            this.closeCRMWhatsappContactAddressDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContactAddress_error', 'error', `Ha ocurrido un error inesperado al actualizar la dirección "${this.input.CRMWhatsappContactAddressName}" del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          }
          this.loader.generalLoader = false;
        }
      },
  
      async deleteCRMWhatsappContactAddress(){
        this.loader.generalLoader = true;
        const deleteCRMWhatsappContactAddressRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgentID
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
          'CRMWhatsappContactAddressID': this.navigation.CRMWhatsappContactAddressID
        };
        const deleteCRMWhatsappContactAddressResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactLocation/functions/deleteCRMWhatsappContactAddress', deleteCRMWhatsappContactAddressRequestQuery);
        if (deleteCRMWhatsappContactAddressResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappContactAddress_success', 'success', `Se ha eliminado la dirección "${this.input.CRMWhatsappContactAddressName}" del contacto`, null, true);
          this.closeCRMWhatsappContactAddressDialog();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappContactAddress_error', 'error', `Ha ocurrido un error inesperado al eliminar la dirección "${this.input.CRMWhatsappContactAddressName}" del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.loader.generalLoader = false;
      },

      validateInputForCRMWhatsappContactAddressDialog(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.navigation.CRMWhatsappContactAddressDialogAction == 'delete'){
          return {success: true, result: null};
        } else if (this.input.CRMWhatsappContactAddressName == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactAddressName)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactAddressName_warning', 'warning', 'El nombre de la ubicación del contacto es obligatorio', null, false);
          return {success: false, result: 'El nombre de la ubicación del contacto es obligatorio'};
        } else if (this.input.CRMWhatsappContactAddressName.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactAddressNameLength_warning', 'warning', 'El nombre de la ubicación del contacto no puede exceder los 100 caracteres de longitud', null, false);
          return {success: false, result: 'El nombre de la ubicación del contacto no puede exceder los 100 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactAddressDescription != null && this.input.CRMWhatsappContactAddressDescription.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactAddressDescriptionLength_warning', 'warning', 'La descripción de la ubicación del contacto no puede exceder los 65535 caracteres de longitud', null, false);
          return {success: false, result: 'La descripción de la ubicación del contacto no puede exceder los 65535 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactAddressAddress == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactAddressAddress)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactAddressAddress_warning', 'warning', 'La dirección del contacto es obligatoria', null, false);
          return {success: false, result: 'La dirección del contacto es obligatoria'};
        } else if (this.input.CRMWhatsappContactAddressAddress.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactAddressAddressLength_warning', 'warning', 'La dirección del contacto no puede exceder los 65535 caracteres de longitud', null, false);
          return {success: false, result: 'La dirección del contacto no puede exceder los 65535 caracteres de longitud'};
        }
        return {success: true, result: null};
      },
      
      async getSystemInformationData(){
        this.loader.getSystemInformationData = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgentID = systemInformation.getCRMAgentID;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactAddressDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
            this.closeCRMWhatsappContactAddressDialog();
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactAddressDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.closeCRMWhatsappContactAddressDialog();
        }
        this.loader.getSystemInformationData = false;
      },

      async openCRMWhatsappContactAddressDialog(CRMWhatsappContactID, CRMWhatsappContactAddressID, CRMWhatsappContactAddressDialogAction){
        await this.getSystemInformationData();
        this.navigation.CRMWhatsappContactID = CRMWhatsappContactID;
        this.navigation.CRMWhatsappContactAddressID = CRMWhatsappContactAddressID;
        this.navigation.CRMWhatsappContactAddressDialogAction = CRMWhatsappContactAddressDialogAction;
        this.navigation.CRMWhatsappContactAddressDialogIsVisible = true;
        if (['update', 'delete'].includes(CRMWhatsappContactAddressDialogAction)) await this.selectCRMWhatsappContactAddressFromCRMWhatsappContactAddressDialog();
        if (['insert', 'update'].includes(CRMWhatsappContactAddressDialogAction)) this.$generalFunctions.default.focusInput(this, 'CRMWhatsappContactAddressName');
      },

      closeCRMWhatsappContactAddressDialog(){
        this.navigation.CRMWhatsappContactAddressDialogIsVisible = false;
        this.$emit('closeCRMWhatsappContactAddressDialog');
      }
    }
  }
</script>